<template>
<div class="page-wrapper">

    <div class="content container-fluid">
        <div class="row align-items-center">
            <div class="col-md-12">
                <div class="page-head-box">
                    <h3>{{page}}</h3>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{{page}}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col-md-12 d-flex">
                <div class="card flex-fill">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card st-card st-c1">
                                    <div class="stats-info">
                                        <div>
                                            <p>Forgot to Mark</p>
                                            <h5>{{this.$store.state.applications.forgot_to_mark}} / {{this.$store.state.applications.forgot_to_mark_total}}</h5>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 0%" aria-valuenow="47" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card st-card st-c2">
                                    <div class="stats-info">
                                        <div>
                                            <p>Special Circumstance</p>
                                            <h5>{{this.$store.state.applications.special_circumstance}} / {{this.$store.state.applications.special_circumstance_total}}</h5>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 0%" aria-valuenow="47" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card st-card st-c3">
                                    <div class="stats-info">
                                        <div>
                                            <p>Meetings</p>
                                            <h5> {{this.$store.state.applications.meeting}} / &#8734; </h5>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-primary" role="progressbar" style="width: 33%" aria-valuenow="87" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row filter-row">
            <div class="col-md-8">
                <div class="row">

                    <div class="col-sm-6 col-md-6">
                        <div class="form-group form-focus mb-0">
                            <input v-model="search" type="text" class="form-control floating">
                            <label class="focus-label">Search {{page}}</label>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4">
                        <a @click="clear" class="btn"><i class="fas fa-close me-2"></i> Clear
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="add-emp-section">

                    <a @click="addNew" class="btn btn-success btn-add-emp" data-bs-toggle="modal" data-bs-target="#add_employee"><i class="fas fa-plus"></i> Add {{page}}</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="table-responsive">
                    <div id="employeelistcontent_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">

                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table table-striped custom-table datatable dataTable no-footer" id="employeelistcontent" aria-describedby="employeelistcontent_info">
                                    <thead>
                                        <tr>

                                            <th class="sorting sorting_asc">Type</th>
                                            <th class="sorting sorting_asc"> Date</th>
                                            <th class="sorting sorting_asc">Time Type</th>
                                            <th class="sorting sorting_asc">Time</th>
                                            <th class="sorting sorting_asc">Reason</th>
                                            <th class="sorting sorting_asc">Status</th>
                                            <th class="sorting sorting_asc">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="odd" v-for="itm in items">
                                            <td class="sorting_1">
                                                <h2 class="table-avatar">
                                                    <a href="/profile" class="avatar">
                                                        <img alt="" src="@/assets/placeholder.png"></a>
                                                    <a href="/template2/profile" class="">
                                                        {{itm.type}}
                                                    </a>
                                                </h2>
                                            </td>
                                            <td>{{itm.dated}}</td>
                                            <td>{{itm.time_type}}</td>
                                            <td>{{itm.time}}</td>
                                            <td>{{itm.reason}}</td>
                                            <td>Line Manager : {{itm.status.line_manager}}<br>
                                                HR : {{itm.status.hr}}
                                            </td>
                                            <td class="text-end ico-sec" v-if="itm.status.line_manager == 'Pending' && itm.status.hr == 'Pending'">
                                                <a @click="edit(itm)"><i class="fas fa-pen"></i></a>
                                                <a @click="del(itm)"><i class="far fa-trash-alt"></i></a>
                                            </td>
                                             <td class="text-end ico-sec" v-if="itm.status.line_manager != 'Pending' || itm.status.hr == 'Pending'">
                                                -
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                                <p v-if="loading" class="loadint">
                                    <img src="@/assets/loading.gif">
                                </p>
                                <p class="loadint" v-if="noData && !loading">No Data Found</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="add" class="modal custom-modal fade" v-bind:class="{'show':add,'showForce':add}" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add {{page}}</h5>
                    <button @click="close" type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="row" v-on:submit="processData">
                        <div class="form-group col-md-12">
                            <label>Application Type <span class="text-danger">*</span></label>
                            <select v-model="data.type" required class="select">
                                <option>Forgot to Mark</option>
                                <option>Special Circumstance</option>
                                <option>Meeting</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Dated <span class="text-danger">*</span></label>
                            <div>
                                <input v-model="data.dated" required class="form-control" value="" type="date">
                            </div>
                        </div>
                        
                        <div class="form-group row">
                            <label class="col-form-label col-md-2">Time Type</label>
                            <div class="col-md-10">
                                <div class="radio"><label><input v-model="data.time_type" type="radio" value="Time In" name="radio"> Time IN </label></div>
                                <div class="radio"><label><input v-model="data.time_type" type="radio" value="Time Out"  name="radio"> Time OUT </label></div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label>Time <span class="text-danger">*</span></label>
                            <div>
                                <input v-model="data.time" required class="form-control" value="" type="time">
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Application Reason <span class="text-danger">*</span></label>
                            <textarea v-model="data.reason" required rows="4" class="form-control"></textarea>
                        </div>
                        <div class="submit-section col-md-12">
                            <a @click="close" class="btn btn-primary cancel-btn" data-bs-dismiss="modal" aria-label="Close">Cancel</a>
                            <button class="btn btn-primary submit-btn">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div v-bind:class="{'show':del_id,'showForce':del_id}" class="modal custom-modal fade" id="delete_employee" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-header">
                        <h3>Delete {{page}}</h3>
                        <p>Are you sure want to delete?</p>
                    </div>
                    <div class="modal-btn delete-action">
                        <div class="row">
                            <div class="col-6">
                                <a @click="delNow" class="btn btn-primary continue-btn">Delete</a>
                            </div>
                            <div class="col-6">
                                <a @click="cancelDel" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            add: false,
            page: "Applications",
            table: 'hr_application',
            items: [],
            data: {},
            loading: true,
            search: '',
            noData: false,
            del_id: false,
            joins: {},
            user:JSON.parse(localStorage.getItem('user')),
            LM:false
        }
    },
    created() {
        document.getElementById("body").classList.add("account-page");
        this.readData();
        this.readExtra('hr_department', 'department');
        this.readExtra('hr_designation', 'designation');
        this.readExtra('hr_setting', 'setting');
        this.readLM()
    },
    methods: {
        sendEmail(itm){
            var i = {
                     subject:`Application for ${itm.type} from ${this.user.name}`,
                     to:{name:this.LM.name,email:this.LM.email},
                     message:{body:`${this.user.name} has applied for ${itm.type}, for ${itm.dated}(${itm.time_type}) at ${itm.time}.Reason : ${itm.reason}. Please login to HRM protal to accept or reject application. Thanks and regards. HRM JBnJaws`,from:`Dear ${this.LM.name}`}
            }
            console.log(i);
            //return;
            axios.post(`${this.$store.state.api_base}send_email_hrm`, i);
        },
        readLM(){
            axios.get(`${this.$store.state.api}hr_employee/_doc/${this.user.line_manager.id}`)
                .then((response) => {
                    this.LM = response.data._source;
                })
        },
        readExtra(table, obj) {
            var filters = [{
                match_phrase: {
                    e: this.$store.state.event
                }
            }]
            axios.post(`${this.$store.state.api}${table}/_search`, {
                    from: 0,
                    size: 500,
                    query: {
                        bool: {
                            must: filters,
                        }
                    }
                })
                .then((response) => {
                    var p = response.data.hits.hits;
                    var c = []
                    for (var i in p) {
                        var d = p[i]._source;
                        d.id = p[i]._id;
                        c.push(d);
                    }
                    this.joins[obj] = c;
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        show() {
            this.add = true;
            document.getElementById('backdrop').classList.add('show');
            document.getElementById('backdrop').classList.remove('hide');
        },
        addNew() {
            this.data = {
                e: this.$store.state.event
            };
            this.show();
        },
        clear() {
            this.search = ''
        },
        del(itm) {
            this.del_id = itm.id;
            document.getElementById('backdrop').classList.add('show');
            document.getElementById('backdrop').classList.remove('hide');
        },
        delNow() {
            axios.delete(`${this.$store.state.api}${this.table}/_doc/${this.del_id}`)
                .then((response) => {
                    this.cancelDel()
                    this.readData()

                })
                .catch((error) => {
                    this.cancelDel()
                    console.log(error);
                })
        },
        cancelDel() {
            this.del_id = false;
            document.getElementById('backdrop').classList.remove('show');
            document.getElementById('backdrop').classList.add('hide');
        },
        filterData() {
            this.noData = false
            if (this.search == '') {
                if (!this.items.length)
                    this.noData = true
                return this.items;
            } else {
                var d = []
                for (var i in this.items) {
                    if (this.items[i].name.indexOf(this.search) >= 0) {
                        d.push(this.items[i])
                    }
                }
                if (!d.length)
                    this.noData = true
                return d;
            }
        },
        edit(itm) {
            this.data = itm;
            this.show();
        },
        close() {
            this.add = false;
            document.getElementById('backdrop').classList.remove('show');
            document.getElementById('backdrop').classList.add('hide');
        },
        readData() {
            //return
            this.loading = true
            this.items = []
            var filters = [{
                term: {
                    e: this.$store.state.event
                }
            },
            {
                term: {
                    employee_id: this.user.machine_id
                }
            }]
            axios.post(`${this.$store.state.api}${this.table}/_search`, {
                    from: 0,
                    size: 500,
                    query: {
                        bool: {
                            must: filters,
                        }
                    }
                })
                .then((response) => {
                    
                    var p = response.data.hits.hits;
                    if(p.length){
                        var z = []
                        for (var i in p) {
                            var d = p[i]._source;
                            d.id = p[i]._id;
                            z.push(d);
                        }
                        this.items = z;
                    }
                    this.loading = false
                    return
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        processData(e) {
            e.preventDefault();
            this.data.employee_id =  this.user.machine_id; 
            if (this.data.id) {
                axios.post(`${this.$store.state.api}${this.table}/_update/${this.data.id}`, {
                        doc: this.data
                    })
                    .then((response) => {
                        this.readData()
                        this.close()
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            } else {
                this.data.status = {hr:'Pending',line_manager:'Pending',hr_comments:'',line_manager_comments:''}
                axios.post(`${this.$store.state.api}${this.table}/_doc`, this.data)
                    .then((response) => {
                         this.sendEmail(this.data)
                        this.readData()
                        this.close()
                        this.$store.dispatch("applications")
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }

        }
    }
}
</script>
